
/*

  I'm duplicating the language-selector component because there is NO WAY to have only one and import it both in app.module AND manager.module. I'm getting errors, errors and more errors. 

  So I'm messily duplicating the component and fuck it.
  
*/

import { Component, OnInit } from '@angular/core';
import { MechanicsService } from './../services/mechanics.service';

@Component({
    selector: 'language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.styl'],
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {

	constructor(public ms: MechanicsService) { }

	ngOnInit() {

		const l = `LanguageSelectorComponent ngOnInit() - `


		if (this.ms.patentsFilters.preferredLanguage) {

			// Attempting to use the preferred user language (title or abstract in Japanese, for instance). If not present, falling back to English

			const langIndex = this.ms.familyLanguages.findIndex(obj => obj.lang === this.ms.patentsFilters.preferredLanguage)

			if (langIndex != -1) {
				// The title/abstract is available in the user's favourite language. Switching to it

				this.ms.selectedLanguageIndex = langIndex
			} else {
				this.ms.selectedLanguageIndex = 0
			}

		}

	}

	changeLanguage(i: number) {

		this.ms.patentsFilters["preferredLanguage"] = this.ms.familyLanguages[i].lang; // {"lang": "en", "source": "WO" }

		localStorage.setItem(`PAT.patentsFilters`, JSON.stringify(this.ms.patentsFilters));

		this.ms.selectedLanguageIndex = +i;
	}

}
